import { BiomeId } from 'mdk-nbt';

export default function locatebiome(biomeId: BiomeId) {
    return `locatebiome ${biomeId}`
}